import { Component,EventEmitter,Optional} from '@angular/core';
import { FormBuilder,Validators,ControlContainer,FormGroup  } from '@angular/forms';
import { Router } from '@angular/router';
import { RloApplicationSearchFormHelper,RloApplicationSearchFormState} from './rlo-application-search-form.helper';
import { BaseFpxFormComponent,ValidatorService } from '@fpx/core';
import { RloapplicationService } from '../rloapplication-service/rloapplication.service';
import { Rloapplication } from '../rloapplication-service/rloapplication.model';


@Component({
 selector: 'app-rlo-application-search-form',
  templateUrl: './rlo-application-search-form.component.html',
  styleUrls: ['./rlo-application-search-form.component.scss'],
  providers : [ RloApplicationSearchFormHelper]
  })

export class RloApplicationSearchFormComponent extends BaseFpxFormComponent<RloApplicationSearchFormHelper, RloApplicationSearchFormState> {
  constructor(
    @Optional() controlContainer: ControlContainer,
    formBuilder: FormBuilder,
    private router: Router,
    public rloApplicationSearchFormHelper: RloApplicationSearchFormHelper,
    private validatorService: ValidatorService

  ) {
    super(formBuilder, router,controlContainer, rloApplicationSearchFormHelper);
  }
      protected  readonly tatBurstOn_minLength : any = 0;
   protected override doPreInit(): void {

   this.addFormControl('search', '',  []    ,[],'change',1,false,0);
  }


  protected override doPostInit(): void {

  }

}
